<template>
  <!-- 添加模态框背景层 -->
  <div class="guide-modal" @click.self="$emit('back')">
    <div class="guide-page">
      <div class="guide-header" :style="{ backgroundImage: headerBackgroundImage }">
        <div class="guide-nav">
          <button class="back-btn" @click="$emit('back')">← 返回</button>
          <button class="continue-btn" @click="$emit('continue')">继续抽签</button>
        </div>
        <div class="guide-city-name">{{ city }}旅游攻略</div>
      </div>
      
      <div class="guide-content" v-if="cityData">
        <div class="guide-section">
          <h3 class="section-title">🏙️ 城市介绍</h3>
          <div class="section-content">
            {{ cityData.city_info.description }}
          </div>
        </div>

        <div class="guide-section">
          <h3 class="section-title">🚗 交通指南</h3>
          <div class="section-content">
            {{ cityData.city_info.transportation }}
          </div>
        </div>

        <div class="guide-section" v-if="cityData.attractions && cityData.attractions.length > 0">
          <h3 class="section-title">🎯 景点推荐</h3>
          <div class="info-grid">
            <div class="info-card" v-for="(attraction, index) in cityData.attractions.slice(0, 6)" :key="index">
              <div class="card-title">{{ attraction.name }}</div>
              <div class="card-content">{{ attraction.description }}</div>
            </div>
          </div>
        </div>

        <div class="guide-section" v-if="cityData.food && cityData.food.length > 0">
          <h3 class="section-title">🍜 美食推荐</h3>
          <div class="info-grid">
            <div class="info-card" v-for="(food, index) in cityData.food.slice(0, 6)" :key="index">
              <div class="card-title">{{ food.name }}</div>
              <div class="card-content">{{ food.description }}</div>
            </div>
          </div>
        </div>

        <div class="guide-section" v-if="cityData.accommodation">
          <h3 class="section-title">🏨 住宿推荐</h3>
          <div class="section-content">
            {{ cityData.accommodation.description }}
          </div>
        </div>

        <div class="guide-section" v-if="cityData.tips">
          <h3 class="section-title">💡 旅游贴士</h3>
          <div class="info-grid">
            <div class="info-card" v-for="(tip, key) in cityData.tips" :key="key">
              <div class="card-title">{{ key }}</div>
              <div class="card-content">{{ tip }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="guide-content" v-else>
        <div class="guide-section">
          <h3 class="section-title">加载中...</h3>
          <div class="section-content">
            正在加载城市攻略数据，请稍候...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuidePage',
  props: {
    city: {
      type: String,
      required: true
    },
    cityData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      headerBackgroundImage: ''
    }
  },
  mounted() {
    this.setRandomHeaderBackground()
  },
  methods: {
    setRandomHeaderBackground() {
      const bgImages = [
        'bg.png',
        'bg1.png',
        'bg2.png',
        'bg3.png',
        'bg4.png',
        'bg5.png',
        'bg6.png',
        'bg7.png',
        'bg8.png',
        'bg9.png',
        'bg10.png'
      ]
      const randomIndex = Math.floor(Math.random() * bgImages.length)
      const selectedImage = bgImages[randomIndex]
      this.headerBackgroundImage = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${require('@/assets/' + selectedImage)})`
    }
  }
}
</script>

<style scoped>
/* 模态框背景层 */
.guide-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

/* 攻略页主体 */
.guide-page {
  background: white;
  border-radius: 20px;
  max-width: 800px;
  max-height: 90vh;
  width: 100%;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  margin: auto;
}

.guide-header {
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 20px 20px 0 0;
}

.guide-nav {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-btn, .continue-btn {
  background: rgba(255,255,255,0.2);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.back-btn:hover, .continue-btn:hover {
  background: rgba(255,255,255,0.3);
  transform: translateY(-2px);
}

.guide-city-name {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}

.guide-content {
  padding: 30px;
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}

.guide-section {
  margin-bottom: 30px;
}

.section-title {
  color: #667eea;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.section-content {
  color: #666;
  line-height: 1.6;
  font-size: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.info-card {
  background: #f8f9ff;
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #667eea;
}

.card-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 16px;
}

.card-content {
  color: #666;
  line-height: 1.5;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .guide-modal {
    padding: 10px;
    align-items: flex-start;
    padding-top: 20px;
  }
  
  .guide-page {
    max-height: calc(100vh - 40px);
    width: calc(100vw - 20px);
    margin: 0;
    border-radius: 15px;
  }
  
  .guide-header {
    height: 120px;
    border-radius: 15px 15px 0 0;
  }
  
  .guide-nav {
    top: 15px;
    left: 15px;
    right: 15px;
  }
  
  .back-btn, .continue-btn {
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .guide-city-name {
    font-size: 18px;
    padding: 0 15px;
  }
  
  .guide-content {
    padding: 15px;
    max-height: calc(100vh - 160px);
  }
  
  .section-title {
    font-size: 18px;
  }
  
  .section-content {
    font-size: 14px;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .info-card {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .guide-modal {
    padding: 5px;
    padding-top: 10px;
  }
  
  .guide-page {
    width: calc(100vw - 10px);
    max-height: calc(100vh - 20px);
    border-radius: 10px;
  }
  
  .guide-header {
    height: 100px;
    border-radius: 10px 10px 0 0;
  }
  
  .guide-nav {
    top: 10px;
    left: 10px;
    right: 10px;
  }
  
  .guide-city-name {
    font-size: 16px;
  }
  
  .guide-content {
    padding: 10px;
    max-height: calc(100vh - 120px);
  }
}
</style>